var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMembers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EFF9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.25C24.8734 17.2493 25.7349 17.4524 26.516 17.843C27.2972 18.2335 27.9765 18.8009 28.5 19.5",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.5C8.0235 18.8009 8.70281 18.2335 9.48398 17.843C10.2651 17.4524 11.1266 17.2493 12 17.25",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.25C20.0711 23.25 21.75 21.5711 21.75 19.5C21.75 17.4289 20.0711 15.75 18 15.75C15.9289 15.75 14.25 17.4289 14.25 19.5C14.25 21.5711 15.9289 23.25 18 23.25Z",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 26.25C13.2884 25.3364 14.0559 24.579 14.9767 24.0529C15.8974 23.5267 16.9395 23.25 18 23.25C19.0605 23.25 20.1026 23.5267 21.0233 24.0529C21.9441 24.579 22.7116 25.3364 23.25 26.25",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 13.5C21.234 12.9568 21.5238 12.4638 21.9302 12.077C22.3366 11.6902 22.8433 11.4251 23.3927 11.3118C23.9422 11.1985 24.5125 11.2416 25.0387 11.4361C25.5649 11.6306 26.0261 11.9688 26.3697 12.4123C26.7134 12.8557 26.9258 13.3867 26.9829 13.9448C27.04 14.5029 26.9394 15.0659 26.6926 15.5697C26.4458 16.0735 26.0627 16.4981 25.5867 16.7951C25.1108 17.0921 24.561 17.2497 24 17.25",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25C11.4389 17.2497 10.8892 17.0921 10.4132 16.7951C9.93727 16.4981 9.55413 16.0735 9.30733 15.5697C9.06053 15.0659 8.95996 14.5029 9.01703 13.9448C9.07411 13.3867 9.28655 12.8557 9.63022 12.4123C9.9739 11.9688 10.435 11.6306 10.9613 11.4361C11.4875 11.2416 12.0577 11.1985 12.6072 11.3118C13.1567 11.4251 13.6634 11.6902 14.0698 12.077C14.4762 12.4638 14.7659 12.9568 14.9062 13.5",
    stroke: "#4C5C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembers);
export default __webpack_public_path__ + "static/media/IconMembers.e3828f770066e5d725cdd2aa9de278ae.svg";
export { ForwardRef as ReactComponent };